import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { ServiceTemplatesService } from 'src/api/v2';
import { SERVICE_TEMPLATE_BY_ID } from 'src/constants/hook-keys';

const useServiceTemplateById = (id: string | undefined) => {
  const [serviceTemplateService] = useState(new ServiceTemplatesService());

  const { data: serviceTemplate, isInitialLoading } = useQuery({
    queryKey: [SERVICE_TEMPLATE_BY_ID, id],
    queryFn: () => serviceTemplateService.getServiceTemplateById(id ?? ''),
    staleTime: 1000 * 60 * 30,
    refetchOnMount: true,
    keepPreviousData: false,
    enabled: !!id,
  });

  return {
    serviceTemplate,
    isInitialLoading,
  };
};

export default useServiceTemplateById;
